


import { Select } from "melco-ui";
import { useTranslation } from "react-i18next";
import { useAllProducts } from "../../hooks/useAllProduts";



type AllProductsGeneralListProps = {
  name?: string;
  onChange?: (value: string | string[]) => void;
  value?: string | string[];

  mode?: string;
  readOnly?: boolean
  disabled?: boolean
};

export const AllProductsGeneralSelect: React.FC<AllProductsGeneralListProps> = ({
  value,
  onChange,
  mode,
  disabled
}) => {
  const { t } = useTranslation();
  const { products } = useAllProducts();

  const stateList = (products).map(
    (products) => ({
      value: products.code,
      label: products.name,
    })
  );



  return (

    <Select
      mode={mode === "multiple" ? "multiple" : undefined}
      allowClear
      placeholder={t('common.products')}
      style={{ width: "100%", minWidth: "150px" }}
      maxTagCount={1}
      options={stateList}
      onChange={onChange}
      value={value}
      disabled={disabled}
    //readonly={disabled}

    />

  );
};
